import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="19"
      fill="none"
      viewBox="0 0 16 19"
    >
      <path
        fill="#0A223C"
        d="M12.27 16.145l3.035-3.035-.87-.87-1.54 1.541V10.01h-1.25v3.772l-1.54-1.54-.87.87 3.035 3.034zm-3.123 2.586v-1.249h6.245v1.25H9.148zm-6.821-3.33c-.41 0-.764-.15-1.06-.446a1.447 1.447 0 01-.446-1.06V2.333c0-.41.149-.763.446-1.06.296-.296.65-.445 1.06-.445h5.78l4.788 4.788v2.567h-1.249V6.241H7.482V2.077H2.326a.244.244 0 00-.176.08.244.244 0 00-.08.176v11.562c0 .064.026.123.08.176.053.054.111.08.176.08h4.996v1.25H2.326z"
      ></path>
    </svg>
  );
}

export default Icon;